<template>
  <FusionBaseDialog
    :open="open"
    :title="$t('map.deviceAQI.title')"
    icon="mdi-information"
    :persistentOverlay="true"
    padded
    data-cy="deviceAQIDialog"
  >
    <p class="aqi-description" data-cy="deviceAQIDescription">
      {{ $t('map.deviceAQI.aqiDescription', { measurementType: measurementTypeText }) }}
    </p>
    <template v-slot:actions>
      <v-spacer></v-spacer>
      <v-btn @click="close" class="bg-primary text-white" data-cy="deviceAQIDoneButton">
        {{ $t('buttons.done') }}
      </v-btn>
    </template>
  </FusionBaseDialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { measurementTypeNames } from '@/store/map/utils'
import { NAMESPACES } from '@/store'
import { MAP_GETTERS } from '@/store/map'

export default defineComponent({
  name: 'DeviceAQIDialog',
  emits: ['close'],
  props: {
    open: { type: Boolean, required: true }
  },
  computed: {
    measurementTypeText() {
      const measurementType: number =
        this.$store.getters[`${NAMESPACES.MAP}/${MAP_GETTERS.GET_MEASUREMENT_TYPE}`]
      return measurementTypeNames[measurementType as keyof typeof measurementTypeNames]
    }
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
})
</script>
